import { AnimatePresence, motion } from "framer-motion";
import Logo from "./logo";

export interface PageLoaderProps {
  loading: boolean;
  children: JSX.Element;
}
const PageLoader = ({ loading, children }: PageLoaderProps) => {
  return (
    <>
      <AnimatePresence>
        {loading && (
          <motion.div
            className="fixed inset-0 z-[1000000] min-h-screen w-full flex flex-col gap-4 items-center justify-center bg-white"
            initial={{ y: 0, opacity: 1 }}
            exit={{ x: "-100%", opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <Logo className="min-w-[300px] animate-pulse" />
          </motion.div>
        )}
      </AnimatePresence>
      {!loading && children}
    </>
  );
};

export default PageLoader;
